import firebase from 'firebase/app'
import 'firebase/firestore'

export const useFB = () => {
  return firebase.firestore()
} 